let pumpFunLink = 'https://pump.fun/coin/4YUZbRtA7b4qWnPMEuREn6C4p1r2c8qsA966oZaMpump';

const urlConfig = {
    baseUrl: '/',
    documentation: 'https://docs.eonbeasts.com/',
    termsAndConditions: 'https://docs.eonbeasts.com/terms-and-conditions',
    privacyPolicy: 'https://docs.eonbeasts.com/privacy-policy',
    buyEon: pumpFunLink? pumpFunLink :'https://pump.fun/coin/4YUZbRtA7b4qWnPMEuREn6C4p1r2c8qsA966oZaMpump',
    tokenomics: 'https://docs.eonbeasts.com/tokenomics',
    roadmap: 'https://docs.eonbeasts.com/roadmap',
    aboutUs: 'https://docs.eonbeasts.com/about-us',
    telegram: 'https://t.me/eonbeasts',
    twitter: 'https://x.com/eonbeasts',
    lore:'https://docs.eonbeasts.com/lore'
}

export default urlConfig;